<app-shop-header *ngIf="currentModule=='shop'"></app-shop-header>
<router-outlet></router-outlet>
<app-shop-footer *ngIf="currentModule=='shop'"></app-shop-footer>
